import Aos from 'aos';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { client_name } from '../../../Helpers/request';
import BannerSlider from '../Bannerslider';
import HomeColSection from './HomeColSection';
import Insta from './insta';
import RingBuilder from './RingBuilder';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import FancyColorDiamonds from './FancyColorDiamonds';
import CustomDesign from './CustomDesign';
import SignupTo from '../../Front/SignupTo'
import Reviews from '../../Front/Reviews'

import Sec1 from "./images/section-1.jpg"
import Sec2 from "./images/section-2.jpg"
import Sec3 from "./images/section-3.jpg"
import Sec4 from "./images/section-4.jpg"
import Sec5 from "./images/section-5.jpg"
import { Col, Container, Row } from 'react-bootstrap';
import yhambnail from '../../../Assets/images/you-thumb.jpeg'
import youtubeImg from '../../../Assets/images/youtube-img.jpg'


const Home = () => {
    const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  
    useEffect(() => {
      Aos.init({
        duration: 1000,
        // disable: 'mobile'
      });
    }, []);
  
    const [isPlaying, setIsPlaying] = useState(false);

  const videoId = "ELvPulD2-Lg";

  const handlePlay = () => {
    setIsPlaying(true);
  };
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{metaDetails?.title}</title>
          <meta name="description" content={metaDetails?.description}></meta>
          <meta name="keywords" content={metaDetails?.keywords}></meta>
          {/*Og Tags */}
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={metaDetails?.title} />
          <meta property="og:description" content={metaDetails?.description} />
          <meta property="og:url" content={metaDetails?.url} />
          <meta property="og:site_name" content={client_name?.c_name} />
        </Helmet>
        <BannerSlider />
        

        <HomeColSection image={Sec1}>
          <div class="inner_right_bx buy-lab-grown-dia">
            <p class="overline">BUY LAB GROWN DIAMONDS</p>
            <h2 class="red-underline">Lab Grown Diamonds</h2>
            <p class="txt_body">A diamond is a diamond, whether pulled from the earth or grown in a lab.</p>
            <p class="txt_link m-0"><Link to="/diamonds/lab" className="brownBtnBorderBox">Shop Now</Link></p>
          </div>
        </HomeColSection>

        <RingBuilder />
        
        <HomeColSection image={Sec2}>
          <div class="inner_right_bx">
            <h2 class="red-underline">Diamond Earrings</h2>
            <p class="txt_body">With a Lifetime Manufacturing Defect Warranty, Price Match Guarantee, 30-day return policy and U.S. craftsmanship, you can be confident in each and every purchase.</p>
            <p class="txt_link m-0"><Link to="/jewelry/earrings" className="brownBtnBorderBox">Shop Now</Link></p>
          </div>
        </HomeColSection>

        <HomeColSection row="reverse" image={Sec3}>
          <div class="inner_right_bx">
            <h2 class="red-underline">Diamond Bracelets</h2>
            <p class="txt_body">With a Lifetime Manufacturing Defect Warranty, Price Match Guarantee, 30-day return policy and U.S. craftsmanship, you can be confident in each and every purchase.</p>
            <p class="txt_link m-0"><Link to="/jewelry/bracelets" className="brownBtnBorderBox">Shop Now</Link></p>
          </div>
        </HomeColSection>
        
        <HomeColSection image={Sec4}>
          <div class="inner_right_bx">
            <h2 class="red-underline">Diamond  Necklaces</h2>
            <p class="txt_body">With a Lifetime Manufacturing Defect Warranty, Price Match Guarantee, 30-day return policy and U.S. craftsmanship, you can be confident in each and every purchase.</p>
            <p class="txt_link m-0"><Link to="/jewelry/necklaces" className="brownBtnBorderBox">Shop Now</Link></p>
          </div>
        </HomeColSection>

        <HomeColSection row="reverse" image={Sec5}>
          <div class="inner_right_bx">
            <h2 class="red-underline">Wedding Rings</h2>
            <p class="txt_body">With a Lifetime Manufacturing Defect Warranty, Price Match Guarantee, 30-day return policy and U.S. craftsmanship, you can be confident in each and every purchase.</p>
            <p class="txt_link m-0"><Link to="/jewelry/wedding-rings" className="brownBtnBorderBox">Shop Now</Link></p>
          </div>
        </HomeColSection>

        <FancyColorDiamonds /> 
        <CustomDesign />
        <Container fluid className='my-5'>
          <Row>
            <Col md={4} xs={12}>
              <div className="rcs_our_story_img_main">
                <iframe width="100%" height="400" src="https://www.youtube.com/embed/WMmf2po_G-E?si=3bLER977aSwLLMnc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <div className="rcs_our_story_img_main">
              <iframe width="100%" height="400" src="https://www.youtube.com/embed/bxhg0tSDQHk?si=7KxYT0PuQY1juv5G" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </Col>
           <Col md={4} xs={12}>
  {/* <div className="rcs_our_story_img_main">
    <iframe
      width="100%"
      height="400"
      src="https://www.youtube.com/embed/ELvPulD2-Lg"
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  </div> */}
 <div style={{ position: "relative", width: "100%", maxWidth: "100%" }}>
  {!isPlaying ? (
    <>
      {/* Thumbnail */}
      <img
        src={yhambnail}
        alt="Video Thumbnail"
        style={{
          width: "100%",
          height: "400px",
          objectFit: "cover",
          cursor: "pointer",
        }}
        onClick={handlePlay}
      />

      {/* YouTube Play Button */}
      {/* <img
        src={youtubeImg}
        alt="Play Button"
        onClick={handlePlay}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "85px",        
          height: "auto",
          cursor: "pointer",
        }}
      /> */}
      <svg   style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "65px",        
          height: "auto",
          cursor: "pointer",
        }}  onClick={handlePlay} height="100%" version="1.1" viewBox="0 0 68 48" width="100%"><path class="ytp-large-play-button-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f03"></path><path d="M 45,24 27,14 27,34" fill="#fff"></path></svg>
    </>
  ) : (
    <iframe
      width="100%"
      height="400"
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    ></iframe>
  )}
</div>
</Col>
          </Row>
        </Container>
        <Insta />
        <Reviews />
        <SignupTo />

        {/* 
        <Ringbuilderhome />
        <RingStyle />
        <ExploreCollection />
        <ShopDiamondShape />
        <Gemstones />
        <Virtualappointment />
        <Customer />
        <Insta />
        <SignupTo /> */}
      </>
    );
  };

export default Home